/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".grey-line{border-bottom:1px solid rgba(204,204,204,.7)}.price-block{margin:0;line-height:27px;font-size:13px}.price-block>[class^=col-]{padding:0 2px}.price-que{cursor:pointer}.price-tag{text-align:center;padding:5px;font-weight:600;text-transform:capitalize;font-size:14px}.srp{font-size:12px}.disc-perc-l{line-height:18px}.popover-content{padding:10px 15px;font-size:12px}.price-block [class^=col-xs-]{padding:0 5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/price-popover.component.less.ngstyle.js.pre-build-optimizer.js